<div class="modal">
  <mat-card-header class="cabecalho">
    <mat-card-title class="titulo">{{ titulo }}</mat-card-title>
    <mat-dialog-actions>
      <button mat-dialog-close class="botao-close">×</button>
    </mat-dialog-actions>
  </mat-card-header>
  <mat-dialog-content class="corpo">
    <mat-card-subtitle class="subtitulo">
      {{ subtitulo }}
    </mat-card-subtitle>

    <mat-card class="inconsistencia">
      <mat-card-content class="erros">
        <div class="titulo-erros">
          <mat-card-title class="titulo-erro">Inconsistências</mat-card-title>
        </div>
        <mat-list class="lista-erros" *ngFor="let mensagem of mensagens">
          <mat-list-item class="item">
            <p class="erro">{{ mensagem }}</p>
          </mat-list-item>
          <mat-divider
            *ngIf="mensagens.indexOf(mensagem) !== mensagens.length - 1"
          ></mat-divider>
        </mat-list>
      </mat-card-content>
    </mat-card>

    <mat-card class="info">
      <div class="centralizar">
        <mat-icon>warning</mat-icon> Escolha
        <strong>&nbsp;Não&nbsp;</strong>
        caso queira permanecer na tela e resolver as inconsistências ou
        <strong>&nbsp;Sim&nbsp;</strong>
        caso queira prosseguir.
      </div>
      <div class="centralizar tudo-maiusculo">
        <mat-icon>warning</mat-icon>
        <strong>Caso prossiga os dados já informados serão perdidos! </strong>
      </div>
    </mat-card>
  </mat-dialog-content>
  <mat-card-footer>
    <mat-dialog-actions class="botoes">
      <button
        (click)="clicouSim()"
        mat-raised-button
        mat-dialog-close
        color="warn"
        class="botao-sim"
      >
        Sim
      </button>
      <button mat-raised-button mat-dialog-close class="botao-nao">Não</button>
    </mat-dialog-actions>
  </mat-card-footer>
</div>
